import { useDocumentTitle } from "@uidotdev/usehooks";

import { StandardContent } from "@/components/App";
import Header from "@/components/Header";
import { PageTitle } from "@/constants/pages";
import { usePageEventTracking } from "@/hooks/event-tracking";

export default function PackUsageHistoryPage() {
  usePageEventTracking();
  useDocumentTitle(PageTitle.PACK_USAGE_HISTORY);

  return (
    <StandardContent>
      <Header className="mb-6">Pack Usage History</Header>
    </StandardContent>
  );
}
